<template lang="html">
  <div>
    <md-layout> 
      <md-dialog ref="ErrorDialog" id="ErrorDialog">
        <md-dialog-title style="padding:0">
          <md-toolbar>
            <div class="md-title">Pago Rechazado</div>
          </md-toolbar>
        </md-dialog-title>
        <md-dialog-content>
          <md-layout>
            Su pedido se encuentra en proceso, el pago fue rechazado por la siguiente razón:</br></br>
            {{this.error}} <br><br>
            Puede intentar nuevamente realizar el pago o comunicarse con nosotros.</br>
            De igual manera puede realizar el pago en un futuro desde el apartado "Mis pedidos" en el menu principal.
          </md-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <md-layout>
            <md-layout md-align="end">
              <md-button class="md-primary md-raised" id="entrar" @click.native="closeModal('ErrorDialog')">Aceptar</md-button>
            </md-layout>
          </md-layout>
        </md-dialog-actions>
      </md-dialog>
      
      <md-dialog ref="ConfirmaDialog" id="ConfirmaDialog">
        <md-dialog-title style="padding:0">
          <md-toolbar>
            <div class="md-title">Pago Autorizado</div>
          </md-toolbar>
        </md-dialog-title>
        <md-dialog-content>
          <md-layout>
            Su pago se realizo con exito, puede ver su pedido en la sección de "Mis pedidos"
          </md-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <md-layout>
            <md-layout md-align="end">
              <md-button class="md-primary md-raised" id="entrar" @click.native="goPedidos">ir al pedido</md-button>
            </md-layout>
          </md-layout>
        </md-dialog-actions>
      </md-dialog>
    </md-layout>

    <md-layout md-gutter="16" style="padding:30px" v-if="error !== ''">
      <md-layout md-flex="100" style="font-size:18px; font-weight:bold;margin-bottom:10px">
        {{pedido.pedido.tipodocto}} {{pedido.pedido.FOLIO}}
      </md-layout>
      <md-layout md-flex="100" style="font-size:18px; font-weight:bold;">
        Total a pagar ${{pedido.pedido.TOTAL}} MXN
      </md-layout>
      <md-layout md-gutter="16" style="max-width:820px; margin-bottom:50px" class="whiteframe">
        <form id="processCard" style="font-size:20px;">

          <md-layout md-flex="100">

            <md-layout 
            md-flex-xlarge="30"
            md-flex-large="30"
            md-flex-medium="30"
            md-flex-small="100"
            md-flex-xsmall="100"
            class="line-right">

              <md-layout md-flex="100" class="padding" md-align="center">Tarjetas de Credito</md-layout>
              <md-layout md-flex="100" md-align="center">
                <img id="" src="./cards1.png" alt="No se encontro la imagen" />
              </md-layout>
              
            </md-layout>

            <md-layout md-flex-xlarge="70"
              md-flex-large="70"
              md-flex-medium="70"
              md-flex-small="100"
              md-flex-xsmall="100">

              <md-layout md-flex="100" class="padding" md-align="center">Tarjetas de débito</md-layout>
              <md-layout md-flex="100" md-align="center">
                <img id="" src="./cards2.png" alt="No se encontro la imagen" />
              </md-layout>
            </md-layout>

          </md-layout>

          <md-layout md-flex="100" style="margin-top:30px; margin-bottom:-15px">
            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100"
            md-hide-small
            >
              Nombre del titular
            </md-layout>
            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100"
            md-hide-small>
              Número de la tarjeta
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" md-gutter="16" class="padding">

            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100"
            >
              <md-layout md-hide-medium-and-up>Nombre del titular</md-layout>
              <md-input-container>
                <label>Como aparece en la tarjeta</label>
                <md-input onkeypress="return (event.charCode > 64 && 
event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode > 31 && event.charCode < 33)" data-openpay-card="holder_name"></md-input>
              </md-input-container>
            </md-layout>

            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100">
            <md-layout md-hide-medium-and-up>Numero de la tarjeta</md-layout>
              <md-input-container>
                <label></label>
                <md-input onkeypress="return !isNaN(Number(event.key))" autocomplete="off" data-openpay-card="card_number" maxlength="16"></md-input>
              </md-input-container>
            </md-layout>

          </md-layout>

          <md-layout md-flex-xlarge="100"
            md-flex-large="100"
            md-flex-medium="100"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-if="parseFloat(pedido.pedido.TOTAL) >= 300">
            <md-layout md-hide-medium-and-up md-flex="50">Meses sin intereses</md-layout>
              <md-input-container>
                <label>Opciones de pago</label>
                <md-select name="pagos" id="pagos" v-model="pagos">
                  <md-option :value="1" >Contado</md-option>
                  <md-option :value="3"  v-if="parseFloat(pedido.pedido.TOTAL) >= 300 && meses >= 3">3 meses sin intereses de {{toMoney(parseFloat(pedido.pedido.TOTAL) / 3)}}</md-option>
                  <md-option :value="6"  v-if="parseFloat(pedido.pedido.TOTAL) >= 600 && meses >= 6">6 meses sin intereses de {{toMoney(parseFloat(pedido.pedido.TOTAL) / 6)}}</md-option>
                  <md-option :value="9" v-if="parseFloat(pedido.pedido.TOTAL) >= 900 && meses >= 9">9 meses sin intereses de {{toMoney(parseFloat(pedido.pedido.TOTAL) / 9)}}</md-option>
                  <md-option :value="12" v-if="parseFloat(pedido.pedido.TOTAL) >= 1200 && meses >= 12">12 meses sin intereses de {{toMoney(parseFloat(pedido.pedido.TOTAL) / 12)}}</md-option>
                </md-select>
              </md-input-container>
            </md-layout>
          

          <md-layout md-flex="100" style="margin-bottom:-15px">
            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100"
            md-hide-small>
              Fecha de expiración
            </md-layout>
            <md-layout md-flex-xlarge="50"
            md-flex-large="50"
            md-flex-medium="50"
            md-flex-small="100"
            md-flex-xsmall="100"
            md-hide-small>
              Código de seguridad
            </md-layout>
          </md-layout>
          <md-layout md-flex="100" class="padding">
            <md-layout md-flex-xlarge="50"
              md-flex-large="50"
              md-flex-medium="50"
              md-flex-small="100"
              md-flex-xsmall="100" md-gutter="40">
              <md-layout md-hide-medium-and-up md-flex="100">Fecha de expiración</md-layout>
              <md-layout md-flex-xlarge="30"
              md-flex-large="30"
              md-flex-medium="30"
              md-flex-small="50"
              md-flex-xsmall="50">
                <md-input-container>
                  <label>Mes</label>
                  <md-input onkeypress="return !isNaN(Number(event.key))" maxlength="2" autocomplete="off" data-openpay-card="expiration_month"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="10" md-hide-small></md-layout>
              <md-layout md-flex-xlarge="30"
              md-flex-large="30"
              md-flex-medium="30"
              md-flex-small="50"
              md-flex-xsmall="50">
                <md-input-container>
                  <label>Año</label>
                  <md-input onkeypress="return !isNaN(Number(event.key))" autocomplete="off" maxlength="2" data-openpay-card="expiration_year"></md-input>
                </md-input-container>
              </md-layout>
            </md-layout>

            <md-layout md-flex-xlarge="50"
              md-flex-large="50"
              md-flex-medium="50"
              md-flex-small="100"
              md-flex-xsmall="100" md-gutter="40">
              <md-layout md-hide-medium-and-up md-flex="100">Código de seguridad</md-layout>
              <md-layout md-flex-xlarge="40"
              md-flex-large="40"
              md-flex-medium="40"
              md-flex-small="50"
              md-flex-xsmall="50">
                <md-input-container>
                  <label>3 digitos</label>
                  <md-input onkeypress="return !isNaN(Number(event.key))" type="password" autocomplete="off" maxlength="4" data-openpay-card="cvv2"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex style="padding-top:15px" md-align="end">
                <img id="" src="./cvv.png" alt="No se encontro la imagen" style="width:163px; height:30px"/>
              </md-layout>
                
            </md-layout>

          </md-layout>

          <md-layout md-flex="100" style="font-size:14px">
            <md-layout md-flex md-align="end" class="line-right" style="padding:10px">
              <div>
                Transacciones realizadas vía: <br>
                <img id="" src="./openpay.png" alt="No se encontro la imagen"/>
              </div>
            </md-layout>
            <md-layout md-flex="40" style="padding:10px">
              <div style="width:40px">
              <img id="" src="./security.png" alt="No se encontro la imagen" style="width:31px; height:37px"/></div>
              <md-layout>
              Tus pagos se realizan de forma segura con encriptaciones de 256 bits</md-layout>
            </md-layout>
            <md-layout md-flex="100" md-align="end">
              <md-button class="md-primary md-raised" @click.native="generateToken">Pagar</md-button>
            </md-layout>
          </md-layout>
        </form>
      </md-layout>
              
    </md-layout>



  </div>
</template>
<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';
import Email from '../../common/functions/smtp'
// import OpenPay from '../../common/functions/openpay'

export default {
  name: 'Inicial',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      resourceOpenPay: this.$api.openpay(this.$resource),
      idPedido: null,
      error: '',
      errorTarjeta: '',
      cliente: {},
      pedidoReady: false,
      transaccion: {},
      id: '',
      isEnvio: true,
      pagarEnLinea: true,
      pagos: [],
      pedidos: [],
      direcciones: [],
      direccion: {
        direccion: '',
        NumExt: '',
        Colonia: '',
        Poblacion: '',
        Recibe: '',
        CP: '',
      },
      observacion: '',
      idDireccion: '',
      envioPedido: {
        ID_clientes_direccion_envios: null,
      },
      tarjetas: [],
      tarjeta: {
        card_number: '',
        holder_name: '',
        expiration_year: '',
        expiration_month: '',
        cvv2: '',
      },
      idTarjeta: '',
      cargo: {},
      iva: 1.16,
      isCustomer: false,
      parametros: {},
      pagos: 1,
      meses: 1
    };
  },
  beforeRouteUpdate(to) {
    this.idPedido = to.params.idPedido;
  },
  computed:{
    direccionValid() {
      if(String(this.idDireccion).length > 0 || this.isEnvio === 'false') {
        return true;
      } else {
        return false;
      }
    },
    subtotal() {
      let total = 0;
      this.cart.forEach((element) => {
        this.iva = element.pIva;
        total += element.precioTotal;
      });
      return total;
    },
    impuestos() {
      let total = 0;
      this.cart.forEach((element) => {
        total += element.impuestos;
      });
      return total;
    },
    envio() {
      if (this.isEnvio == 'false') {
        return 0;
      }
      return (this.subtotal * (this.parametros.porcentaje_envio / 100)) * this.iva
    }
  },
  components: {},
  methods: {
    toMoney,
    agregarTarjeta() {
      if(!this.tarjeta.card_number && String(this.tarjeta.card_number).length !== 16){
        this.$toast.create('El numero de tarjeta debe contener 16 digitos', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.holder_name && !String(this.tarjeta.holder_name).length > 0){
        this.$toast.create('El campo Nombre es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.expiration_year && !String(this.tarjeta.expiration_year).length > 0){
        this.$toast.create('El campo año expiración es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.expiration_month && !String(this.tarjeta.expiration_month).length > 0){
        this.$toast.create('El campo mes expiracion es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.cvv2 && String(this.tarjeta.cvv2).length !== 3){
        this.$toast.create('El campo cvv2 debe contener 3 digitos', 'snack', 3E3);
        return;
      } 
     
      this.saveTarjeta();
    },
    saveCustomer(){
      const cliente = {
        parameters: {
          external_id: this.cliente.cliente.idinterno,
          name: this.cliente.cliente.nombre.trim(),
          last_name: this.cliente.cliente.nombre.trim(),
          email: this.cliente.email ? this.cliente.email.trim() : '',
          requires_account: false,
          phone_number: this.cliente.cliente.telefono ? this.cliente.cliente.telefono.trim() : '',
          address: {
              line1: this.cliente.cliente.direccion ? this.cliente.cliente.direccion.trim(): '' + ' ' + this.cliente.cliente.numext ? this.cliente.cliente.numext.trim() : '',
              line2: this.cliente.cliente.colonia ? this.cliente.cliente.colonia.trim() : '',
              line3: this.cliente.cliente.ubicacion ? this.cliente.cliente.ubicacion.trim() : '',
              state: this.cliente.cliente.entfed ? this.cliente.cliente.entfed.trim() : '' ,
              city: this.cliente.cliente.poblacion ? this.cliente.cliente.poblacion.trim() : '',
              postal_code: this.cliente.cliente.cp ? this.cliente.cliente.cp.trim() : '' ,
              country_code: 'MX'
          }
        }
      }
      this.resourceOpenPay.guardarCliente(cliente)
        .then((response) => {
          if (response.data.response === 'result'){
            this.saveCargo3DSecure();
            // this.saveCargo3DSecure();
            this.saveAll();
            this.deleteAllCart();
          }
        })
        .catch((err) => {
          this.$error(this, err.error.message);
        });
    },
    goPedidos() {
      this.savePago();
    },
    getPedido(){
      const idPedido = this.idPedido;
      this.resourcePedido.getPedido({ idPedido })
        .then((response) => {          
          this.pedido = response.data;
          this.error = 'por pagar';
          if (this.errorTarjeta !== '' && this.errorTarjeta !== null){
            this.error = 'La tarjeta ingresada no permite meses sin intereses, no se realizo ningun cargo'
            this.openModal('ErrorDialog');
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    getClienteOpenPay(){
      const idUsuario = this.cliente.cliente.idinterno;
      this.resourceOpenPay.getCliente({ idUsuario })
        .then((response) => {
          this.isCustomer = response.data.response === 'result';
          if (this.isCustomer) {
            this.getTarjetas();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    getTarjetas(){
      const idUsuario = this.cliente.cliente.idinterno;
      this.resourceOpenPay.getTarjetasCliente({ idUsuario })
        .then((response) => {
  
          this.tarjetas = response.data.result;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    saveAll() {
      
      // if(String(this.pagarEnLinea) === 'false') {
        this.savePago();
      // } else {
      //   this.saveCargoTarjeta();
      // }
    },
    saveDireccion() {
      const idCliente = this.cliente.cliente.idinterno;
      this.resourceCliente.postDireccion({ idCliente }, this.direccion)
          .then((response) => {
            this.getDirecciones();
            this.closeModal('DireccionModal');
            this.$toast.create('Direccion creada', 'snack', 3E3);
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    savePago(){
      if (this.pedido.pedido.tipodocto.trim() !== 'STSHOP'){
        this.saveAbono();
        return;
      }
      let idFormaPago = '';
      const formaPago = String(this.pagarEnLinea) === 'true' ? '04' : 'POR COBRAR';
      this.pedido.pagos.forEach((element) => {
        if(element.descripcion.substring(0, 2) === formaPago) {
          idFormaPago = element.idformapago;
        }
      })
      const pago = {
        idformapago: idFormaPago,
        valor: this.pedido.pedido.TOTAL
      };

      this.resourcePedido.pagos({ idPedido: this.idPedido }, pago)
        .then((response) => {
          //this.$toast.create('Pedido Creado', 'snack', 3E3);
          if(this.pedido.pedido.tipodocto.trim() === 'STSHOP'){
            this.$router.push({ name: 'pedidoForm', params: { idPedido: this.idPedido } });
          } else {
            this.$router.push({ name: 'facturaForm', params: { idPedido: this.idPedido } });            
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },

    saveAbono(){
      let idFormaPago = '';
      const formaPago = String(this.pagarEnLinea) === 'true' ? '04' : 'POR COBRAR';
      this.pedido.pagos.forEach((element) => {
        if(element.descripcion.substring(0, 2) === formaPago) {
          idFormaPago = element.idformapago;
        }
      })
      const pago = {
        idformapago: idFormaPago,
        valor: this.pedido.pedido.TOTAL
      };

      this.resourcePedido.abono({ idPedido: this.idPedido }, pago)
        .then((response) => {
          //this.$toast.create('Pedido Creado', 'snack', 3E3);
          this.enviarMailPago();
          this.enviarMailPagoVendedor();
          if(this.pedido.pedido.tipodocto.trim() === 'STSHOP'){
            this.$router.push({ name: 'pedidoForm', params: { idPedido: this.idPedido } });
          } else {
            this.$router.push({ name: 'facturaForm', params: { idPedido: this.idPedido } });            
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },

    generateToken() {
      // var _id = 'maxclx0toodpoo2enq1m', _apiKey = "pk_c5a1385205ec4a15986ce00545527675";
      var _id = 'mr6bhgnplipssu4qz7c6', _apiKey = "pk_c62246bfa7434650aaf5eb8d3497b21f";
      var formCard = OpenPay.extractFormInfo($('#processCard'));
      $('#dataCard').text(JSON.stringify(formCard));
      // OpenPay.setSandboxMode(true);
      OpenPay.setSandboxMode(false);
      try {
          OpenPay.setId(_id);
          OpenPay.setApiKey(_apiKey);
          OpenPay.token.extractFormAndCreate($('#processCard'), this.successCard, this.errorCard, 'XYMapj0elM');
      } catch (e) {
          alert(e);
      }
    },
    successCard(response){
      // var content = '', results = document.getElementById('resultDetail');
      // content += 'Id tarjeta: ' + response.data.id+ '<br />';
      // content += 'A nombre de: ' + response.data.holder_name + '<br />';
      // content += 'Marca de tarjeta usada: ' + response.data.brand + '<br />';
      // results.innerHTML = content;
      this.idTarjeta = response.data.id;
      if (this.isCustomer) {
          // this.saveCargoTarjeta();
          this.saveCargo3DSecure();
        } else {
          this.saveCustomer()
        }
    },
    errorCard(error){
        // alert('Fallo en la transacción');
        // var content = '', results = document.getElementById('resultDetail');
        // content += 'Estatus del error: ' + response.data.status + '<br />';
        // content += 'Error: ' + response.message + '<br />';
        // content += 'Descripción: ' + response.data.description + '<br />';
        // content += 'ID de la petición: ' + response.data.request_id + '<br />';
        // results.innerHTML = content;
        alert('El pago no pudó ser realizado, ' + error.data.description );
    },    
    getCargo() {  
      const idUsuario = this.cliente.cliente.idinterno;
      this.resourceOpenPay.getCargo({ idUsuario, idCargo: this.id })
          .then((response) => {
            this.transaccion = response.data;
            if (this.transaccion.status === 'failed') {
              this.getError();
            } else {
              this.savePago();
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    getError() {
      switch(this.transaccion.error_code){
        case 3001:
          this.error = 'La tarjeta fue declinada.';
          break;
        case 3002:
          this.error = 'La tarjeta ha expirado.';
          break;
        case 3003:
          this.error = 'La tarjeta no tiene fondos suficientes.';
          break;
        case 3004:
          this.error = 'La tarjeta ha sido identificada como una tarjeta robada.';
          break;
        case 3005:
          this.error = 'La tarjeta ha sido identificada como una tarjeta fraudulenta.';
          break;
        case 3006:
          this.error = 'La operación no esta permitida para este cliente o esta transacción.';
          break;
        case 3008:
          this.error = 'La tarjeta no es soportada en transacciones en linea.';
          break;
        case 3009:
          this.error = 'La tarjeta fue reportada como perdida.';
          break;
        case 3010:
          this.error = 'El banco ha restringido la tarjeta.';
          break;
        case 3011:
          this.error = 'El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.';
          break;
        case 3012:
          this.error = 'Se requiere solicitar al banco autorización para realizar este pago.';
          break;
        case 2010:
          this.error = 'Error en autenticación con el banco';
          break;
        default: 
          this.error = 'Error no identificado';
          break;
      }
      this.openModal('ErrorDialog');
      console.log(this.error)
    },
    saveCargo3DSecure() {  
      const deviceSessionId = OpenPay.deviceData.setup("processCard", "deviceIdHiddenFieldName");
      const idUsuario = this.cliente.cliente.idinterno;
      let cargo = {};
      if(this.pagos > 1){
        cargo = {
          parameters: {
            source_id: this.idTarjeta,
            method: 'card',
            amount: this.pedido.pedido.TOTAL,
            currency: 'MXN',
            description: 'Pago de pedido ' + this.pedido.pedido.FOLIO,
            order_id: this.pedido.pedido.FOLIO,
            device_session_id : deviceSessionId,
            redirect_url: this.parametros.sitio + "/confirmacion/" + this.idPedido,
            use_3d_secure: "true",
            payment_plan: {"payments": this.pagos}
          }
        }
      }else{
        cargo = {
          parameters: {
            source_id: this.idTarjeta,
            method: 'card',
            amount: this.pedido.pedido.TOTAL,
            currency: 'MXN',
            description: 'Pago de pedido ' + this.pedido.pedido.FOLIO,
            order_id: this.pedido.pedido.FOLIO,
            device_session_id : deviceSessionId,
            redirect_url: this.parametros.sitio + "/confirmacion/" + this.idPedido,
            use_3d_secure: "true"
          }
        }
      }     

      this.resourceOpenPay.postCargo({ idUsuario, idCard: this.idTarjeta }, cargo)
          .then((response) => {
             if (response.data.response === 'result'){
              window.location.href = response.data.result.payment_method.url
              // this.$toast.create('Pago efectuado', 'snack', 3E3);
              // this.saveAll();
              // this.deleteAllCart();
            }
            else {
              window.location.href = this.parametros.sitio + "/confirmacion/" + this.idPedido + "?error=tarjeta"
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    savePedido() {
      let detalles = [];
      this.cart.forEach((element) => {
        const detalle = {
          idarticulo: element.idinterno,
          cantidad: element.cantidad,
          precio: element.precio / element.pIva
        }
        if (element.idsecundaria) {
          detalle.idsecundaria = element.idsecundaria; 
        }
        if (element.id_presentacion) {
          detalle.id_presentacion = element.id_presentacion; 
        }
        detalles.push(detalle);
      });
      const envio = {
        idarticulo: parametros.articulo_envio,
        cantidad: 1,
        precio: this.envio / this.iva
      }
      detalles.push(envio)
      const pedido = {
        documento: {
          turno: 'M',
          idvendedor: 'STSHOPVEND',
          idcliente: this.cliente.cliente.idinterno,
          detalles: detalles,
          _esBorrador: false,
          IDALMACEN: this.parametros.almacen
        },
        envio: {ID_clientes_direccion_envios: this.idDireccion},
        observacion: this.observacion,
      }
      this.resourcePedido.guardar(pedido)
        .then((response) => {
          this.pedido = response.data;
          this.idPedido = this.pedido.pedido.idinterno;
          this.$toast.create('Pedido Creado', 'snack', 3E3);
          if (this.pagarEnLinea === true || this.pagarEnLinea === 'true') {
            if (this.isCustomer) {
              this.saveCargoTarjeta();
              // this.saveCargo3DSecure();
            } else {
              this.saveCustomer()
            }
          } else {
            this.savePago();
          }
          this.enviarMailCliente();
          this.enviarMailVendedor('diegochilomer@hotmail.com');
          this.enviarMailVendedor(this.pedido.empresa.email);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    deleteFromCart(index) {
      this.cart.splice(index, 1);
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
    },
    deleteAllCart(){
      while(this.cart.length > 0) {
        this.deleteFromCart(0);
      }
    },
    enviarMailCliente(){
      let direccion = '';
      if (this.pedido.direccion) {
        direccion =`${this.pedido.direccion.Recibe} <br/> ${this.pedido.direccion.direccion}, ${this.pedido.direccion.NumExt} ( ${this.pedido.direccion.NumInt})<br/>  ${this.pedido.direccion.Colonia}, ${this.pedido.direccion.CP} <br/> ${this.pedido.direccion.Poblacion}, ${this.pedido.direccion.EntFed}, ${this.pedido.direccion.Pais}<br/> ${this.pedido.direccion.telefono} <br/>`
      } else {
        direccion = 'El pedido lo podras recoger en tienda.'
      }
      let detalles = '';
      this.pedido.detalles.forEach((el) => {
        const detalle = `<tr style='border-bottom:1px solid #acb7c0'> <td style='width: 110px; padding: 10px'> <img style='max-height: 90px;' src='${this.parametros.ruta_imagen}${el.foto}' alt='No se encontro la imagen' /> </td> <td style='text-align: left; padding: 10px'> <label style='font-size: 18px'>${el.descripcion}</label><br> Precio: ${toMoney(parseFloat(el.precio))} <br> Cantidad: ${Math.round(el.cantidad)} </td><td style='text-align: right; padding: 10px'> <label style='font-size: 18px'>${toMoney(parseFloat(el.precioneto) * el.cantidad)}</label><br> </td></tr>`
        detalles = detalles + detalle
      })
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img style='max-height: 90px;' src='${this.parametros.ruta_imagen}${this.pedido.empresa.foto}' alt='No se encontro la imagen' /></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b> <br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion}, ${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}<br></td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Gracias por comprar con nosotros</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Tu Pedido: ${this.pedido.pedido.FOLIO}</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><b>Dirección de envio:</b><br>${direccion}</td><td style='text-align:right; padding: 10px'><table style='font-weight: bold; color: #585858; margin-left: auto'><tr><td colsan='2'><b>Resumen del pedido:</b><br><br></td></tr><tr><td style='width:100px'>SubTotal:</td><td>${toMoney(parseFloat(this.pedido.pedido.subtotal))}</td></tr><tr><td>IVA:</td><td> ${toMoney(parseFloat(this.pedido.pedido.iva))}</td></tr><tr><td>Total</td><td>${toMoney(parseFloat(this.pedido.pedido.TOTAL))}</td></tr></table></td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'>${detalles}</table><br><br><div style="width:650px;font-size:14px; font-style: oblique; text-align: right">Este pedido fue creado con STShop (<a href="http://www.superticket.mx">superticket.mx</a>)</div></div></body></html>`
      Email.send({
        Host : "smtp.ionos.mx",
        Username : "contacto@stshop.mx",
        Password : "Compart33461",
        To : this.cliente.email,
        From : "contacto@stshop.mx",
        Subject : `Pedido ${this.pedido.pedido.FOLIO} STSHOP`,
        Body : mail
      }).then(
        // message => alert(message)
      );
    },
    enviarMailVendedor(email){
      let direccion = '';
      if (this.pedido.direccion) {
        direccion =`${this.pedido.direccion.Recibe} <br/> ${this.pedido.direccion.direccion}, ${this.pedido.direccion.NumExt} ( ${this.pedido.direccion.NumInt})<br/>  ${this.pedido.direccion.Colonia}, ${this.pedido.direccion.CP} <br/> ${this.pedido.direccion.Poblacion}, ${this.pedido.direccion.EntFed}, ${this.pedido.direccion.Pais}<br/> ${this.pedido.direccion.telefono} <br/>`
      } else {
        direccion = 'El pedido se recogerá en tienda.'
      }
      let detalles = '';
      this.pedido.detalles.forEach((el) => {
        const detalle = `<tr style='border-bottom:1px solid #acb7c0'> <td style='width: 110px; padding: 10px'> <img style='max-height: 90px;' src='https://stshop.club:85/Ejemplo2/imagen/${el.foto}' alt='No se encontro la imagen' /> </td> <td style='text-align: left; padding: 10px'> <label style='font-size: 18px'>${el.descripcion}</label><br> Precio: ${toMoney(parseFloat(el.precio))} <br> Cantidad: ${Math.round(el.cantidad)} </td><td style='text-align: right; padding: 10px'> <label style='font-size: 18px'>${toMoney(parseFloat(el.precioneto) * el.cantidad)}</label><br> </td></tr>`
        detalles = detalles + detalle
      })
      const mail = `<html ><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:18px'><tr><td><img style='max-height: 90px;' src='https://stshop.club:85/Ejemplo2/imagen/${this.pedido.empresa.foto}' alt='No se encontro la imagen'/></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b><br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion}, ${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}</tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Haz recibido un Pedido!</b></td></tr></table><table style='width:650px; border:1px solid #acb7c0; border-radius: 10px;'><tr><td style='margin-left:auto; margin-right:auto; padding: 10px'><b>Pedido: ${this.pedido.pedido.FOLIO}</b><br>${this.cliente.cliente.comercial} <br>${this.cliente.RFC}</td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><b>Dirección de envio:</b><br>${direccion}</td><td style='text-align:right; padding: 10px'><table style='font-weight: bold; color: #585858; margin-left: auto'><tr><td colsan='2'><b>Resumen del pedido:</b><br><br></td></tr><tr><td style='width:100px'>SubTotal:</td><td>${toMoney(parseFloat(this.pedido.pedido.subtotal))}</td></tr><tr><td>IVA:</td><td> ${toMoney(parseFloat(this.pedido.pedido.iva))}</td></tr><tr><td>Total</td><td>${toMoney(parseFloat(this.pedido.pedido.TOTAL))}</td></tr></table></td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'>${detalles}</table><br><br></div></body></html>`
      Email.send({
        Host : "smtp.ionos.mx",
        Username : "contacto@stshop.mx",
        Password : "Compart33461",
        To : email,
        From : "contacto@stshop.mx",
        Subject : `Pedido ${this.pedido.pedido.FOLIO} STSHOP`,
        Body : mail
      }).then(
        // message => alert(message)
      );
    },
    enviarMailPago(){
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img height="90" width="300" style='max-height: 90px; height:90px;max-width:300px ' src='${this.parametros.ruta_imagen}${this.pedido.empresa.foto}' alt='No se encontro la imagen' /></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b><br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion},${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}<br></td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>¡Gracias por su pago!</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Documento: ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO}</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'><tr><td style='text-align: left; padding: 10px'>Hemos Recibido el pago del documento ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO} por ${toMoney(parseFloat(this.pedido.pedido.TOTAL))} MXN</td></tr></table><br><br><div style="width:650px;font-size:14px; font-style: oblique; text-align: right">Este pedido fue creado con STShop (<a href="http://www.superticket.mx">superticket.mx</a>)</div></div></body></html>`
      Email.send({
        Host : "smtp.ionos.mx",
        Username : "contacto@stshop.mx",
        Password : "Compart33461",
        To : this.cliente.email,
        From : "contacto@stshop.mx",
        Subject : `Pago de ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO} confirmado`,
        Body : mail
      }).then(
        // message => alert(message)
      );
    },
    enviarMailPagoVendedor(){
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img height="90" width="300" style='max-height: 90px; height:90px;max-width:300px ' src='${this.parametros.ruta_imagen}${this.pedido.empresa.foto}' alt='No se encontro la imagen' /></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b><br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion},${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}<br></td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>¡Haz recibido un pago!</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Documento: ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO}</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'><tr><td style='text-align: left; padding: 10px'>Haz recibido un pago del documento ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO} por ${toMoney(parseFloat(this.pedido.pedido.TOTAL))} MXN</td></tr></table><br><br><div style="width:650px;font-size:14px; font-style: oblique; text-align: right">Este pedido fue creado con STShop (<a href="http://www.superticket.mx">superticket.mx</a>)</div></div></body></html>`
      Email.send({
        Host : "smtp.ionos.mx",
        Username : "contacto@stshop.mx",
        Password : "Compart33461",
        To : this.pedido.empresa.email,
        From : "contacto@stshop.mx",
        Subject : `Pago de ${this.pedido.pedido.tipodocto} ${this.pedido.pedido.FOLIO} confirmado`,
        Body : mail
      }).then(
        // message => alert(message)
      );
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  mounted() {
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
    this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {};  
    this.isEnvio =  this.parametros.envio === 'ambos' || this.parametros.envio === 'domicilio' ? 'true' : 'false';
    this.pagarEnLinea =  this.parametros.pago === 'ambos' || this.parametros.pago === 'enLinea' ? 'true' : 'false';
    this.idPedido = this.$route.params.idPedido;
    const url = new URL(window.location.href);
    this.id = url.searchParams.get("id");
    this.meses =  this.parametros.pagos_meses;
    debugger
    this.errorTarjeta = url.searchParams.get("error");
    this.cart = window.cart;
    this.getPedido();
    if (this.id !== '' && this.id !== null) {
      this.getCargo();
    }else if (this.errorTarjeta !== '' && this.errorTarjeta !== null){
      this.error = 'La tarjeta ingresada no permite meses sin intereses, no se realizo ningun cargo'
      this.openModal('ErrorDialog');
    } else {
      if (this.pagarEnLinea === 'true' || this.pagarEnLinea === true ){
        this.getClienteOpenPay();
      }
    }
  },
};
</script>

<style lang="scss">
  #DireccionModal,#TarjetaModal{
    .md-dialog{
      width:700px;
    }
  }
   #openpayCtnr * {
    color: #444;
    font-family: Lato;
    font-size: 16px;
    font-weight: 300;
  }

  #openpayCtnr ::-webkit-input-placeholder {
    font-style: italic;
  }

  #openpayCtnr :-moz-placeholder {
    font-style: italic;
  }

  #openpayCtnr ::-moz-placeholder {
    font-style: italic;
  }

  #openpayCtnr :-ms-input-placeholder {
    font-style: italic;
  }

  #openpayCtnr strong {
    font-weight: 700;
  }

  #openpayCtnr a {
    cursor: pointer;
    display: block;
    text-decoration: none;
  }

  #openpayCtnr a.button {
    border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    text-align: center;
    font-size: 21px;
    font-weight: 400;
    padding: 12px 0;
    width: 100%;
    display: table;
    background: #E51F04;
    background: -moz-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #E51F04), color-stop(100%, #A60000));
    background: -webkit-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -o-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -ms-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: linear-gradient(top, #E51F04 0%, #A60000 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#E51F04', endColorstr='#A60000', GradientType=0);
  }

  #openpayCtnr a.button i {
    margin-right: 10px;
  }

  #openpayCtnr a.button.disabled {
    background: none repeat scroll 0 0 #ccc;
    cursor: default;
  }

  #openpayCtnr .bkng-tb-cntnt {
    float: left;
    width: 800px;
  }

  #openpayCtnr .bkng-tb-cntnt a.button {
    color: #fff;
    float: right;
    font-size: 18px;
    padding: 5px 20px;
    width: auto;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.o {
    background: none repeat scroll 0 0 rgba(0, 0, 0, 0);
    color: #e51f04;
    border: 1px solid #e51f04;
  }

  #openpayCtnr .bkng-tb-cntnt a.button i {
    color: #fff;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.o i {
    color: #e51f04;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.right i {
    float: right;
    margin: 2px 0 0 10px;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.left {
    float: left;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.disabled.o {
    border-color: #ccc;
    color: #ccc;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.disabled.o i {
    color: #ccc;
  }

  #openpayCtnr .pymnts {
    float: left;
    width: 800px;
  }

  #openpayCtnr .pymnts * {
    float: left;
  }

  #openpayCtnr .sctn-row {
    margin-bottom: 35px;
    width: 800px;
  }

  #openpayCtnr .sctn-col {
    width: 375px;
  }

  #openpayCtnr .sctn-col.l {
    width: 425px;
  }

  #openpayCtnr .sctn-col input {
    border: 1px solid #ccc;
    font-size: 18px;
    line-height: 24px;
    padding: 10px 12px;
    width: 333px;
  }

  #openpayCtnr .sctn-col label {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 10px;
    width: 100%;
  }

  #openpayCtnr .sctn-col.x3 {
    width: 300px;
  }

  #openpayCtnr .sctn-col.x3.last {
    width: 200px;
  }

  #openpayCtnr .sctn-col.x3 input {
    width: 210px;
  }

  #openpayCtnr .sctn-col.x3 a {
    float: right;
  }

  #openpayCtnr .pymnts-sctn {
    width: 800px;
  }

  #openpayCtnr .pymnt-itm {
    margin: 0 0 3px;
    width: 800px;
  }

  #openpayCtnr .pymnt-itm h2 {
    background-color: #e9e9e9;
    font-size: 24px;
    line-height: 24px;
    margin: 0;
    padding: 28px 0 28px 20px;
    width: 780px;
  }

  #openpayCtnr .pymnt-itm.active h2 {
    background-color: #e51f04;
    color: #fff;
    cursor: default;
  }

  #openpayCtnr .pymnt-itm div.pymnt-cntnt {
    display: none;
  }

  #openpayCtnr .pymnt-itm.active div.pymnt-cntnt {
    background-color: #f7f7f7;
    display: block;
    padding: 0 0 30px;
    width: 100%;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row {
    margin: 20px 30px 0;
    width: 740px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col {
    width: 345px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.l {
    width: 395px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col input {
    width: 303px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half {
    width: 155px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half.l {
    float: left;
    width: 190px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half input {
    width: 113px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.cvv {
    background-image: url("./cvv.png");
    background-position: 156px center;
    background-repeat: no-repeat;
    padding-bottom: 30px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.cvv div.sctn-col.half input {
    width: 110px;
  }

  #openpayCtnr .openpay {
    float: right;
    height: 60px;
    margin: 10px 30px 0 0;
    width: 435px;
  }

  #openpayCtnr .openpay div.logo {
    background-image: url("./openpay.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    border-right: 1px solid #ccc;
    font-size: 12px;
    font-weight: 400;
    height: 50px;
    padding: 0px 20px 0 0;
  }

  #openpayCtnr .openpay div.shield {
    background-image: url("./security.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    font-size: 12px;
    font-weight: 400;
    margin-left: 20px;
    padding: 20px 0 0 40px;
    width: 200px;
  }

  #openpayCtnr .card-expl {
    float: left;
    height: 80px;
    margin: 20px 0;
    width: 800px;
  }

  #openpayCtnr .card-expl div {
    background-position: left 45px;
    background-repeat: no-repeat;
    height: 70px;
    padding-top: 10px;
  }

  #openpayCtnr .card-expl div.debit {
    background-image: url("./cards2.png");
    margin-left: 20px;
    width: 540px;
  }

  #openpayCtnr .card-expl div.credit {
    background-image: url("./cards1.png");
    border-right: 1px solid #ccc;
    margin-left: 30px;
    width: 209px;
  }

  #openpayCtnr .card-expl h4 {
    font-weight: 400;
    margin: 0;
  }
  .line-right{
    border-right:1px solid #ccc !important;
}

.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/spa/pagos/confirmacion.vue